import Router from 'vue-router';
import Vue from 'vue';

Vue.use(Router)
const isView = ['visual.ahtsaas.com', 'visual.anhutong.life'].indexOf(window.location.host) !== -1;
const vueRouter = new Router({
    base: process.env.VUE_APP_PATH || '',
    mode: process.env.VUE_APP_MODE || 'history',
    imgBase: 'http://anhutong.oss-cn-shenzhen.aliyuncs.com/common/imgage/dataScreen/',
    routes: [
        {
        path: '/',
        component: () => import( /* webpackChunkName: "page" */ '@/page/index'),
        // 只有从指定域名加载页面时才允许访问Admin页面
        beforeEnter: (to, from, next) => {
            if (isView) {
                next('/screen');
            } else {
                next();
            }
        },
        children: [{
            path: '',
            component: () => import( /* webpackChunkName: "page" */ '@/page/list'),
            // 只有从指定域名加载页面时才允许访问Admin页面
            beforeEnter: (to, from, next) => {
                if (isView) {
                    next('/screen');
                } else {
                    next();
                }
            },

        },
            {
                path: 'category',
                component: () => import( /* webpackChunkName: "page" */ '@/page/list/category'),
                // 只有从指定域名加载页面时才允许访问Admin页面
                beforeEnter: (to, from, next) => {
                    if (isView) {
                        next('/screen');
                    } else {
                        next();
                    }
                },
            }, {
                path: 'db',
                component: () => import( /* webpackChunkName: "page" */ '@/page/list/db'),
                // 只有从指定域名加载页面时才允许访问Admin页面
                beforeEnter: (to, from, next) => {
                    if (isView) {
                        next('/screen');
                    } else {
                        next();
                    }
                },
            }, {
                path: 'map',
                component: () => import( /* webpackChunkName: "page" */ '@/page/list/map'),
                // 只有从指定域名加载页面时才允许访问Admin页面
                beforeEnter: (to, from, next) => {
                    if (isView) {
                        next('/screen');
                    } else {
                        next();
                    }
                },
            }, {
                path: 'document',
                component: () => import( /* webpackChunkName: "page" */ '@/page/list/document'),
                // 只有从指定域名加载页面时才允许访问Admin页面
                beforeEnter: (to, from, next) => {
                    if (isView) {
                        next('/screen');
                    } else {
                        next();
                    }
                },
            }, {
                path: 'glob',
                component: () => import( /* webpackChunkName: "page" */ '@/page/list/glob'),
                // 只有从指定域名加载页面时才允许访问Admin页面
                beforeEnter: (to, from, next) => {
                    if (isView) {
                        next('/screen');
                    } else {
                        next();
                    }
                },
            }, {
                path: 'components',
                component: () => import( /* webpackChunkName: "page" */ '@/page/list/components'),
                // 只有从指定域名加载页面时才允许访问Admin页面
                beforeEnter: (to, from, next) => {
                    if (isView) {
                        next('/screen');
                    } else {
                        next();
                    }
                },

            }, {
                path: 'record',
                component: () => import( /* webpackChunkName: "page" */ '@/page/list/record'),
                // 只有从指定域名加载页面时才允许访问Admin页面
                beforeEnter: (to, from, next) => {
                    if (isView) {
                        next('/screen');
                    } else {
                        next();
                    }
                },
            }]
    },
        {
        path: '/create',
        name: 'create',
        component: () =>
            import( /* webpackChunkName: "page" */ '@/page/create'),
        // 只有从指定域名加载页面时才允许访问Admin页面
        beforeEnter: (to, from, next) => {
            if (isView) {
                next('/screen');
            } else {
                next();
            }
        },
    },
        {
        path: '/build',
        name: 'build',
        component: () =>
            import( /* webpackChunkName: "page" */ '@/page/build'),
        // 只有从指定域名加载页面时才允许访问Admin页面
        beforeEnter: (to, from, next) => {
            if (isView) {
                next('/screen');
            } else {
                next();
            }
        },
    },
        {
        path: '/build/:id',
        name: 'build',
        component: () =>
            import( /* webpackChunkName: "page" */ '@/page/build'),
        // 只有从指定域名加载页面时才允许访问Admin页面
        beforeEnter: (to, from, next) => {
            if (isView) {
                next('/screen');
            } else {
                next();
            }
        },
    },
        {
        path: '/view/:id',
        name: 'view',
        component: () =>
            import( /* webpackChunkName: "page" */ '@/page/view'),
        // 只有从指定域名加载页面时才允许访问Admin页面
        beforeEnter: (to, from, next) => {
            if (isView) {
                next('/screen');
            } else {
                next();
            }
        },
    },
        {
        path: '/screen/:randomData',
        name: 'screen',
        component: () =>
            import( /* webpackChunkName: "page" */ '@/page/screen'),
    },
        {
            path: '/:pathMatch(.*)*',
            name: 'not-found',
            component: () => import('@/page/404.vue')
        },
    ]
})
export default vueRouter;
